import Hero from './hero'
import HowItWorks from './how-it-works'
import WhoWeAre from './who-we-are'

export function Home() {
  return (
    <>
      <Hero />
      <WhoWeAre />
      <HowItWorks />
    </>
  )
}
